module.exports = __webpack_public_path__ + "img/HF.9f3cb946.png";